// @ts-strict-ignore
import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ModalModule} from "src/app/shared/components/modal/modal.module";
import {SharedModule} from "src/app/shared/shared.module";
import {FlatComponent} from "./flat/flat";
import {ModalComponent} from "./modal/modal";
import {TimeOfUseTariffPriceChartComponent} from "./modal/timeOfUseTariffPriceChart";

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    ModalModule,
  ],
  declarations: [
    ModalComponent,
    FlatComponent,
    TimeOfUseTariffPriceChartComponent,
  ],
  exports: [
    FlatComponent,
  ],
})
export class TimeOfUseTariffPrice {
}
